import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

class TourGuide extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { tourGuide, t } = this.props;

    return (
      <section className='fe-trip-tour-guide'>
        <div className='container'>
          <div className='row position-relative'>
            <div className='col-lg-8'>
              {Object.keys(tourGuide).length > 0 ? (
                <div className='fe-trip-main-guide'>
                  <h4 className='fe-trip-main-heading'>
                    {t('trip:yourGuide')}
                  </h4>
                  <div className='fe-trip-main-guide-info'>
                    <div className='fe-trip-main-guide-img'>
                      <div className='fe-trip-main-guide-thumb'>
                        <div className='fe-u-thumb-square'>
                          <img src={tourGuide.avatar} alt='' />
                        </div>
                      </div>
                      <h5 className='fe-trip-main-guide-name'>
                        {tourGuide.name}
                      </h5>
                    </div>
                    <div className='fe-trip-main-guide-desc'>
                      <h5 className='fe-trip-main-guide-name'>
                        {tourGuide.name}
                      </h5>
                      <blockquote>
                        <p>{tourGuide.quote}</p>
                      </blockquote>
                      {tourGuide.language_spoken.length > 0 ? (
                        <>
                          <h5 className='fe-trip-main-language-heading'>
                            {t('trip:languagesSpoken')}
                          </h5>
                          <ul className='fe-trip-main-language-list'>
                            {tourGuide.language_spoken.map((language, idx) => (
                              <li key={idx}>{language}</li>
                            ))}
                          </ul>
                        </>
                      ) : null}
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

TourGuide.propTypes = {
  tourGuide: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired
};

export default withTranslation()(TourGuide);
